import { Factory } from 'miragejs';

export default Factory.extend({
  active: (i) => (i > 0 && i < 6 ? true : false),
  dayOfWeek: (i) => ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][i],
  startTime: '08:00:00',
  endTime: '18:00:00',
});
